import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'
import ReactSelect from 'react-select'
import FuncFetch from '../../Utilities/funcFetch'
import Contact from '../../AccountDetailsPopup/AccordionItems/Contact/Contact'
import { useMsal } from '@azure/msal-react'
import './CollectorClaimModal.css'
import TakeClaimAssignment from '../NCD/TakeClaimAssignment';
import CloseOrOpenAccountButton from '../NCD/CloseOrOpenAccountButton'
import useFetch from '../../Utilities/useFetch'
import ErrorBoundary from '../../Auth/ErrorBoundary'
import CollectorClaimView from './ClaimView/CollectorClaimView'
import AdminPostAccountHeader from './ClaimView/AdminPostAccountHeader/AdminPostAccountHeader'
import { CiEdit } from 'react-icons/ci'

function CollectorClaimModal({
  selectedClaim,
  setSelectedClaim,
  claims,
  show,
  setShow
}) {
//Claim 1412256 Mercury West | CAPA-00312345 
  const { instance, accounts } = useMsal();
  const { REACT_APP_API_URL } = process.env;
  const [claimOptions, setClaimOptions] = useState();
  const [phones, setPhones] = useState();
  const [emails, setEmails] = useState();
  const [activities, setActivities] = useState();
  const [accountIsOpen, setAccountIsOpen] = useState();
  const {data: isCollectorAdmin} = useFetch(true,`${REACT_APP_API_URL}/Claims/IsCollectorAdmin`,'GET')
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [showAdminPostAccountHeader,setShowAdminPostAccountHeader] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [account, setAccount] = useState({
    "account":{}
  });

  const loadClaimDetails = (debtorId) => {
    if (!debtorId) {
      return Promise.resolve();
    }

    setLoading(true);

    return FuncFetch(`${REACT_APP_API_URL}/Claims/GetAccountDetail`,{debtorid:debtorId},'GET',null,instance,accounts)
      .then(response=>{
        if(response){
          setAccountIsOpen((response.account.accountStatus?.toUpperCase())==='OPEN'?true:false)
          // This is a workaround to add an empty object to the payment history array if it is empty
          // If there are values in the array, it adds an empty object to the beginning of the array
          // so there is an empty row for the user to fill out
          if(response.paymentHistory[0]===null){
            response.paymentHistory[0]={}
          }else{
            response.paymentHistory.unshift({})
          }
          setAccount(response)
          setActivities(response.activities);
          setPhones(response.phones)
          setEmails(response.emailAddresses)
          setLoading(false);
        }
      })
      .catch(error=>{
        setError(error)
        setLoading(false);
      })
  }

  useEffect(()=>{
    if(selectedClaim){
        setAccount({
          "account":{}
        })
        setError(null)
        setActivities(null)
        setPhones(null)
        setEmails(null)
        loadClaimDetails(selectedClaim)
    }
  // eslint-disable-next-line
  },[selectedClaim])

  useEffect(()=>{
    // The API returns [null] if there are no results
    if(claims&&claims[0]!==null){
      setClaimOptions(claims.map(claim=>{
        return{value:claim.debtorId,label:'Row: '+claim.rowNumber+' Claim: '+claim.debtorId}
      }))
    }
  },[claims])

  const handleHide = () => { 
    setSelectedClaim(null)
    setShow(false)
   }

  const handleCopyClaimNumber = async () => {
    await navigator.clipboard.writeText(`${account.account.debtorID}`)
    setCopySuccess(true)
    setTimeout(() => setCopySuccess(false), 2000)
  }

  const goToNextClaim = () => { 
    let currentClaimIndex = claimOptions.findIndex(claim=>claim.value===selectedClaim)
    if(currentClaimIndex!==(claimOptions.length-1)){
      setSelectedClaim(null)
      setSelectedClaim(claimOptions[currentClaimIndex+1].value)
    }
   }

   const goToPrevClaim = () => { 
     let currentClaimIndex = claimOptions.findIndex(claim=>claim.value===selectedClaim)
     if(currentClaimIndex!==0){
      setSelectedClaim(null)
      setSelectedClaim(claimOptions[currentClaimIndex-1].value)
    }

   }

  const updateAccountFieldsAndActivities = (fieldsAndActivities) => { 
    let { nextContactDate, activities, adverseCarriers, paymentHistory } = fieldsAndActivities
    let fieldsWithoutActivities = {...fieldsAndActivities}
    delete fieldsWithoutActivities.activities
    // I have to use this parsing method to turn the date from UTC JSON to readable in the UI
    nextContactDate = new Date(Date.parse(nextContactDate)).toJSON()
    let newAccountInfo = {...account}
    newAccountInfo.account = {...newAccountInfo.account,...fieldsWithoutActivities}
    newAccountInfo.account.NCD = nextContactDate
    newAccountInfo.account.nextContactDate = nextContactDate
    if(adverseCarriers){
      newAccountInfo.adverseCarriers = adverseCarriers
    }
    if(paymentHistory){
      newAccountInfo.paymentHistory = paymentHistory
    }
    setAccount(newAccountInfo)
    if(activities){
      setActivities(activities)
    }
   }

  return (
    <Modal show={show} onHide={handleHide} fullscreen={true} >
      {showAdminPostAccountHeader&&<AdminPostAccountHeader show={showAdminPostAccountHeader} setShow={setShowAdminPostAccountHeader} account={account} setAccount={setAccount} />}
        <Modal.Header closeButton>
            {isCollectorAdmin&&
              <CloseOrOpenAccountButton className='margin-right' accountIsOpen={accountIsOpen} setAccountIsOpen={setAccountIsOpen} account={account.account} updateAccountFieldsAndActivities={updateAccountFieldsAndActivities} />
            }
            <h4 className='margin-right'>Claim {selectedClaim} {account?.client?.clientName} | {account?.account?.clientRefNo} | {account.account?.projectID} | {account.account?.debtorStatus}</h4>
            {accountIsOpen?
              <h4 className='margin-right'>| Account Open {account.account?.accountStatusDate?.split('T')[0]}</h4>
            :accountIsOpen===false&&
              <h4>| Account Closed {account.account?.accountStatusDate?.split('T')[0]}</h4>
            }
            <Button
              variant='outline-secondary'
              className='margin-right'
              onClick={handleCopyClaimNumber}
              disabled={!account.account?.debtorID}
            >
              Copy Claim#
            </Button>
            <div className='collector-claim-modal-assign-button'>
              {(account.account?.debtorID&&account.account.collector?.toUpperCase()==='TBD'&&!isCollectorAdmin)?
                <TakeClaimAssignment debtorId={account.account.debtorID} updateAccountFieldsAndActivities={updateAccountFieldsAndActivities} />
              :null}
            </div>
            {isCollectorAdmin&&
              <Button onClick={()=>setShowAdminPostAccountHeader(true)}><CiEdit /></Button>
            }
        </Modal.Header>
      {copySuccess && <Alert variant='success' className='m-3 mb-0'>Copied to clipboard</Alert>}
      {error?<h4>Claim does not exist</h4>:
      <>
        <Modal.Body>
          <ErrorBoundary>
            {selectedClaim?
              <>
              <div className='search-results-wrapper margin-bottom'>
                {(claims&&claimOptions)?
                  <div className='search-results-dropdown'>
                    <Button onClick={()=>goToPrevClaim()}>Previous</Button>
                    <ReactSelect 
                      className='full-width'
                      options={claimOptions} 
                      value={claimOptions.find(claim=>claim.value===selectedClaim)} 
                      onChange={(e)=>setSelectedClaim(e.value)} 
                      />
                      <Button onClick={()=>goToNextClaim()}>Next</Button>
                  </div>
                :
                  <div></div>
                }
                {(phones&&emails)?
                  <>
                    <Contact 
                      phones={phones} 
                      setPhones={setPhones} 
                      emails={emails} 
                      setEmails={setEmails} 
                      activities={activities} 
                      debtorID={account.account?.debtorID} 
                      setActivities={setActivities}
                      updateAccountFieldsAndActivities={updateAccountFieldsAndActivities}
                    />
                  </>
                :
                  <Spinner animation='border' />
                }
              </div>
              <CollectorClaimView
                claimNumber={selectedClaim} 
                activities={activities}
                setActivities={setActivities}
                loading={loading}
                account={account}
                setAccount={setAccount}
                reloadClaim={loadClaimDetails}
                updateAccountFieldsAndActivities={updateAccountFieldsAndActivities}
              />
              </>
            :null}
          </ErrorBoundary>
        </Modal.Body>
      </>
      }
    </Modal>
  )
}

export default CollectorClaimModal